"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedListAttrJSONSchema = void 0;
const attribute_js_1 = require("./attribute.js");
const getFormattedListAttrJSONSchema = (attr) => ({
    type: 'array',
    items: (0, attribute_js_1.getFormattedAttrJSONSchema)(attr.elements)
});
exports.getFormattedListAttrJSONSchema = getFormattedListAttrJSONSchema;
